import { Icon } from '@w7/ui'
import './create.css'

export function PasswordInput({
  id,
  describedBy,
  invalid,
  valid,
  value,
  onChange,
  autoComplete,
  visible,
  onToggleVisible,
  disabled,
}: {
  id: string
  describedBy?: string
  invalid?: boolean
  /** Green border once the value meets policy (ignored when invalid). */
  valid?: boolean
  value: string
  onChange: (value: string) => void
  autoComplete?: string
  visible: boolean
  onToggleVisible: () => void
  disabled?: boolean
}) {
  return (
    <span className="w7-password">
      <input
        id={id}
        className="w7-input"
        type={visible ? 'text' : 'password'}
        aria-describedby={describedBy}
        aria-invalid={invalid || undefined}
        data-valid={!invalid && valid ? 'true' : undefined}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoComplete={autoComplete}
        disabled={disabled}
      />
      <button
        type="button"
        className="w7-password-toggle"
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={onToggleVisible}
        disabled={disabled}
      >
        <Icon name={visible ? 'eye-off' : 'eye'} size={16} />
      </button>
    </span>
  )
}
